import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import { useSetCurrentPractitionerGlobalState } from '~libs.shared.account';
import { setLocalStorageScopeKey } from '~libs.typescript';

type AppInitializerProps = Readonly<{
   children: JSX.Element | null;
}>;

export const AppInitializer = (props: AppInitializerProps): JSX.Element | null => {
   const setCurrentPractitionerGlobalState = useSetCurrentPractitionerGlobalState();

   const { loading: currentPractitionerLoading, error: currentPractitionerError } = useCqrsFind<PractitionerDetails>(
      () => new CurrentPractitionerQuery(),
      {
         onSuccess: (currentPractitioner) => {
            // TODO DREGAB-25028 Przeniesienie funkcjonalność integracji z Pharmindexem do panelu support
            if (currentPractitioner) {
               setCurrentPractitionerGlobalState(currentPractitioner);
               setLocalStorageScopeKey(currentPractitioner.clientIdentifier);
            }
         },
      }
   );

   if (currentPractitionerError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   if (currentPractitionerLoading) {
      return <LoaderSpinner />;
   }

   return props.children;
};
